import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import PurposesListComponent from '../components/PurposesListComponent';
import HeaderComponent from '../components/HeaderComponent';

class PurposesListPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <PurposesListComponent location={this.props.location}/>
            </div>
        );
    }
}

export default PurposesListPage;